import { Ship } from '@/typing/api/ship.class';
import getEnv from '@/utils/environment/getEnvironment';
import showNotification from '@/utils/notification';
import axios from 'axios';
import { saveAs } from 'file-saver';

function apiBaseUrl(): string {
    return getEnv().apiBaseUrl ?? '';
}

export async function exportData(
    to: string,
    from: string,
    ship: Ship
): Promise<any> {
    try {
        const result: Blob = await axios.get(
            `${apiBaseUrl()}/v1/data/export?shipId=${
                ship.id
            }&from=${from}&to=${to}`,
            {
                responseType: 'blob',
            }
        );

        if (result.size === 0) {
            showNotification(
                'Er is geen data beschikbaar voor de huidige filters.'
            );
            return;
        }

        const filename = `baggerraporten_export_${ship.name.replace(
            ' ',
            '_'
        )}.xlsx`;

        saveAs(result, filename);
    } catch (error) {
        showNotification(
            'Er ging iets fout tijdens het downloaden van het rapport.'
        );
    }
}
